import { render, staticRenderFns } from "./TravelManagerOrAuthPersonProfileCard.vue?vue&type=template&id=7d0a2d4f&scoped=true"
import script from "./TravelManagerOrAuthPersonProfileCard.vue?vue&type=script&lang=ts"
export * from "./TravelManagerOrAuthPersonProfileCard.vue?vue&type=script&lang=ts"
import style0 from "./TravelManagerOrAuthPersonProfileCard.vue?vue&type=style&index=0&id=7d0a2d4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0a2d4f",
  null
  
)

export default component.exports